import { render, staticRenderFns } from "./update-email.vue?vue&type=template&id=7d4fd972&scoped=true&"
import script from "./update-email.vue?vue&type=script&lang=js&"
export * from "./update-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4fd972",
  null
  
)

export default component.exports